import { createSlice } from "@reduxjs/toolkit";
import { createWorkspaceWidgetDataAction, getAgencyAction, getWorkspaceWidgetDataAction, updateWorkspaceWidgetDataAction, workspaceDetailsAction, workspaceWidgetReportDataAction, workspaceWidgetReportExportAction } from "../actions/AgencyAction";

export interface Agency {
    smtp: {
        host: string;
        port: number;
        user: string;
        pass: string;
        verified?: boolean;
    };
    branding: {
        primaryColor: string;
        secondaryColor: string;
    };
    _id: string;
    added_by?: string;
    owner_id?: string;
    name: string;
    logoUrl: string | null;
    customDomain?: string;
    privacyPolicyUrl?: string | null;
    termsOfConditionUrl?: string | null;
    setup_call_link?: string | null;
    setup_call_header?: string | null;
    setup_call_description?: string | null;
    domainVerified: boolean;
    status: "pending_setup" | "active" | "inactive";
    createdAt: string; // ISO date string
    updatedAt: string; // ISO date string
    __v: number;
    owner_email?: string;
    sslStatus?: string;
    sslError?: string | null;
}

export interface IAgencySlice {
    agency: Agency | null,
    loading: boolean,
    error: any,
    isedit: boolean,
    workspaceWidgetDataLoading: boolean,
    workspaceWidgetData: any | null,
    workspaceWidgetReportDataLoading: boolean,
    workspaceWidgetReportData: any | null
    workspaceWidgetReportExportData: any,
    workspaceWidgetReportExportLoading: boolean;
}

const initialState: IAgencySlice = {
    agency: null,
    loading: false,
    error: null,
    isedit: false,
    workspaceWidgetDataLoading: false,
    workspaceWidgetData: null,
    workspaceWidgetReportDataLoading: false,
    workspaceWidgetReportData: null,
    workspaceWidgetReportExportData: [],
    workspaceWidgetReportExportLoading: false
}


const AgencySlice = createSlice({
    name: "agency",
    initialState,
    reducers: {
    },
    extraReducers(builder) {
        builder.addCase(getAgencyAction.pending, (state) => {
            state.loading = true;
            state.error = null;
        })
            .addCase(getAgencyAction.fulfilled, (state, action) => {
                state.loading = false;
                state.agency = action.payload.agency;
                state.isedit = state.agency?._id ? true : false;
                state.error = null;
            })
            .addCase(getAgencyAction.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload;
            })

            // workspace details
            .addCase(workspaceDetailsAction.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(workspaceDetailsAction.fulfilled, (state, action) => {
                state.loading = false;
                state.agency = action.payload.data;
                state.isedit = state.agency?._id ? true : false;
                state.error = null;
            })
            .addCase(workspaceDetailsAction.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload;
            })

            // get workspace widget 
            .addCase(getWorkspaceWidgetDataAction.pending, (state) => {
                state.workspaceWidgetDataLoading = true;
            })
            .addCase(getWorkspaceWidgetDataAction.fulfilled, (state, action) => {
                state.workspaceWidgetDataLoading = false;
                state.workspaceWidgetData = action.payload;
            })
            .addCase(getWorkspaceWidgetDataAction.rejected, (state) => {
                state.workspaceWidgetDataLoading = false;
            })

            // create workspace widget
            .addCase(createWorkspaceWidgetDataAction.pending, (state) => {
                state.workspaceWidgetDataLoading = true;
            })
            .addCase(createWorkspaceWidgetDataAction.fulfilled, (state, action) => {
                state.workspaceWidgetDataLoading = false;
                state.workspaceWidgetData = action.payload;
            })
            .addCase(createWorkspaceWidgetDataAction.rejected, (state) => {
                state.workspaceWidgetDataLoading = false;
            })



            // update workspace widget
            .addCase(updateWorkspaceWidgetDataAction.pending, (state) => {
                state.workspaceWidgetDataLoading = true;
            })
            .addCase(updateWorkspaceWidgetDataAction.fulfilled, (state, action) => {
                state.workspaceWidgetDataLoading = false;
                state.workspaceWidgetData = action.payload;
            })
            .addCase(updateWorkspaceWidgetDataAction.rejected, (state) => {
                state.workspaceWidgetDataLoading = false;
            })

            // widget report data
            .addCase(workspaceWidgetReportDataAction.pending, (state) => {
                state.workspaceWidgetReportDataLoading = true;
            })
            .addCase(workspaceWidgetReportDataAction.fulfilled, (state, action) => {
                state.workspaceWidgetReportDataLoading = false;
                state.workspaceWidgetReportData = action.payload;
            })
            .addCase(workspaceWidgetReportDataAction.rejected, (state) => {
                state.workspaceWidgetReportDataLoading = false;
            })

            // get workspace widget report export
            .addCase(workspaceWidgetReportExportAction.pending, (state) => {
                state.workspaceWidgetReportExportLoading = true;
            })
            .addCase(workspaceWidgetReportExportAction.fulfilled, (state, action) => {
                state.workspaceWidgetReportExportLoading = false;
                state.workspaceWidgetReportExportData = action.payload;
            })
            .addCase(workspaceWidgetReportExportAction.rejected, (state) => {
                state.workspaceWidgetReportExportLoading = false;
            })

    },
})

export default AgencySlice.reducer;